import {
  LIST_USER_SUCCESS,
  LIST_USER_FAILURE,
  COMPANY_LIST_SUCCESS,
  COMPANY_LIST_FAILURE,
  USER_ROLES_SUCCESS,
  USER_ROLES_FAILURE,
  GET_REGION_SUCCESS,
  GET_REGION_FAILURE,
  CREATE_USER_SUCCESS,
  CREATE_USER_FAILURE,
  EDIT_USER_SUCCESS,
  EDIT_USER_FAILURE,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAILURE,
  TOGGLE_USER_SUCCESS,
  TOGGLE_USER_FAILURE,
  SEND_FAQ_QUERY_SUCCESS,
  SEND_FAQ_QUERY_ERROR,
  ACTIVATE_DEACTIVATE_COMPANY,
  CLEAR_ACTIVATE_DEACTIVATE_RES,
  DELETE_COMPANY,
  CLEAR_DELETE_COMPANY_RES,
} from '../actions/UserMasterActions'

const initialState = {
  loading: true,
  companyListLoading: true,
  regionLoading: true,
  userRoleLoading: true,
  userList: [],
  userListCount: null,
  companyList: [],
  roleList: [],
  regionList: [],
  createUserResponse: {},
  createUserLoading: true,
  editLoading: true,
  editData: {},
  updateUser: {},
  updateUserLoading: true,
  toggleUser: {},
  toggleUserLoading: true,
  faqQueryloading: true,
  faqQueryRes: {},
}

const userMasterReducer = function (state = initialState, action) {
  switch (action.type) {
    case LIST_USER_SUCCESS: {
      return {
        ...state,
        loading: false,
        userList: action.payload.data.viewuser,
        userListCount: action.payload.data.total_count,
      }
    }
    case LIST_USER_FAILURE: {
      return {
        ...state,
        loading: false,
        userList: {},
      }
    }
    case COMPANY_LIST_SUCCESS: {
      return {
        ...state,
        companyListLoading: false,
        companyList: action.payload.data,
      }
    }
    case COMPANY_LIST_FAILURE: {
      return {
        ...state,
        companyListLoading: false,
        companyList: {},
      }
    }
    case USER_ROLES_SUCCESS: {
      return {
        ...state,
        userRoleLoading: false,
        roleList: action.payload.data,
      }
    }
    case USER_ROLES_FAILURE: {
      return {
        ...state,
        userRoleLoading: false,
        roleList: {},
      }
    }
    case GET_REGION_SUCCESS: {
      return {
        ...state,
        regionLoading: false,
        regionList: action.payload,
      }
    }
    case GET_REGION_FAILURE: {
      return {
        ...state,
        regionLoading: false,
        regionList: {},
      }
    }
    case CREATE_USER_SUCCESS: {
      return {
        ...state,
        createUserLoading: false,
        createUserResponse: action.payload,
      }
    }
    case CREATE_USER_FAILURE: {
      return {
        ...state,
        createUserLoading: false,
        createUserResponse: {},
      }
    }
    case EDIT_USER_SUCCESS: {
      return {
        ...state,
        editLoading: false,
        editData: action.payload,
      }
    }
    case EDIT_USER_FAILURE: {
      return {
        ...state,
        editLoading: false,
        editData: {},
      }
    }
    case UPDATE_USER_SUCCESS: {
      return {
        ...state,
        updateUserLoading: false,
        updateUser: action.payload,
      }
    }
    case UPDATE_USER_FAILURE: {
      return {
        ...state,
        updateUserLoading: false,
        updateUser: {},
      }
    }
    case TOGGLE_USER_SUCCESS: {
      return {
        ...state,
        toggleUserLoading: false,
        toggleUser: action.payload,
      }
    }
    case TOGGLE_USER_FAILURE: {
      return {
        ...state,
        toggleUserLoading: false,
        toggleUser: {},
      }
    }
    case SEND_FAQ_QUERY_SUCCESS: {
      return {
        ...state,
        faqQueryloading: false,
        faqQueryRes: action.payload,
      }
    }
    case SEND_FAQ_QUERY_ERROR: {
      return {
        ...state,
        faqQueryloading: false,
        faqQueryRes: {},
      }
    }
    case ACTIVATE_DEACTIVATE_COMPANY: {
      return {
        ...state,
        companyActivateDeActivateResponse: action.payload,
      }
    }
    case CLEAR_ACTIVATE_DEACTIVATE_RES: {
      return {
        ...state,
        companyActivateDeActivateResponse: undefined,
      }
    }
    case DELETE_COMPANY: {
      return {
        ...state,
        companyDeleteResponse: action.payload,
      }
    }
    case CLEAR_DELETE_COMPANY_RES: {
      return {
        ...state,
        companyDeleteResponse: undefined,
      }
    }

    default: {
      return {
        ...state,
      }
    }
  }
}

export default userMasterReducer
